import Image from 'next/image';
import { sharedAssets } from '../../../../public/images/shared/sharedAssets';
import { MsalHelper } from '../helpers/msalHelper';

export function NotAuthenticated() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-[url(/images/login/background.jpg)] bg-cover bg-center">
      <div className="flex flex-col justify-center items-center bg-transparent backdrop-blur-md p-8 rounded-lg border mx-3">
        <div>
          <Image
            src={sharedAssets.logo}
            alt="InformAG Logo"
            width={300}
            priority
          />
        </div>

        <h1 className="font-semibold text-3xl text-gray-200 text-center">
          Hello! You are not authenticated.
        </h1>
        <button
          className="bg-black hover:bg-gray-600 text-white transition-all font-semibold py-2 px-4 border border-gray-400 rounded-lg shadow mt-3"
          type="button"
          onClick={() => MsalHelper.handleLogin()}
        >
          Log In
        </button>
      </div>
    </div>
  );
}
